<template>
  <div class="dialog-app-panel" :class="showDrawPanel ? 'dialog-show' : ''">
    <app-panel
      :isExpand="showDrawPanel"
      :title="'图纸[' + buildInfo ? buildInfo.buildingName : '' + ']'"
      :transparent="true"
      :width="1000"
      isScreen
      @cancel="handleClosePanel"
      @screen="handleScreenPanel"
    >
      <!-- canvas图纸 -->
      <div class="floors" v-if="buildInfo">
        <div
          class="floor-item"
          v-for="item in buildInfo.floorInfo"
          :key="item.buildingCode"
          :class="item.buildingCode == floorInfo.buildingCode ? 'active' : ''"
          @click="handleFloors(item)"
        >
          <i class="el-icon-caret-right"></i>
          <div class="floor-title">
            {{ item.buildingName }}
          </div>
        </div>
      </div>
      <div class="canvasMain">
        <div
          class="canvasMainT"
          :style="{
            width: vW + '%',
            height: vH + '%',
            marginTop: getMarginTop + 'px',
            marginLeft: getMarinLeft + 'px',
          }"
        >
          <img
              id="floorImg"
              :src="floorInfo ? getImgPath(floorInfo.fileCode) : ''"
          />
          <canvas
              id="mycanvas"
              style="cursor: all-scroll"
              @mousewheel="mouseScroll"
              @DOMMouseScroll="mouseScroll"
              @mousedown="handleDomMoveStart"
              :width="cW"
              :height="cH"
          ></canvas>
        </div>
      </div>
      <div class="coord">
        <span> 【 缩放比例 {{ vW }}% 】 </span>
        【相对坐标 X：{{ pointX }} ，Y：{{ pointY }} 】
      </div>
      <canvasTip
        v-if="showDeviceTip"
        :data="deviceInfo"
        @tipClose="showDeviceTip = false"
        class="canvasTip"
        :style="{
          left: tipStyle.left + 'px',
          top: tipStyle.top + 'px',
        }"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePanel" type="info" :loading="subLoading">
          关闭
        </el-button>
      </span>
    </app-panel>
  </div>
</template>

<script>
import { Bus } from "$utils";
import deviceMap from "@src/modules/cameraList/components/deviceMap";
import appPanel from "@src/components/business/app-panel/index.vue";
import canvasTip from "./canvasTip.vue";
import { api } from "../api";
export default {
  name: "floor-draw",
  props: {
    panelType: {
      type: Number,
      default: 0,
    },
  },
  mixins: [deviceMap],
  components: {
    appPanel,
    canvasTip,
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  watch: {
    getMarinLeft() {
      this.matchTip();
    },
    getMarginTop() {
      this.matchTip();
    },
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
        this.matchTip();
      });
    },
  },
  data() {
    return {
      cW: 0,
      cH: 0,
      showDrawPanel: false,
      floorInfo: {},
      buildInfo: {},
      subLoading: false,
      pointX: 0,
      pointY: 0,
      tipImg: null,
      showDeviceTip: false, //设备信息弹窗
      tipStyle: { left: 0, top: 0 },
      canvasList: [], //渲染的设备
      deviceInfo: {}, //选中的设备信息
    };
  },
  created() {
    this.tipImg = new Image();
    this.tipImg.src = require("/public/images/theme/newDark/map/cameraDefault.png");
  },
  mounted() {
    this.canvasClick();
    this.getCanvasWH();
    let that = this;
    window.onresize = function () {
      that.getCanvasWH();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    handleFloors(item) {
      console.log(item);
      if (item.buildingCode == this.floorInfo.buildingCode) {
        return;
      }
      this.floorInfo = JSON.parse(JSON.stringify(item));
      this.getIndoorDeviceList(item);
    },
    handleScreenPanel() {
      this.getCanvasWH();
    },
    canvasClick() {
      let that = this;
      var canvas = document.getElementById("mycanvas");
      console.info('>>>>>>>>>>>>>>>>>>>>>>>', canvas)
      var x, y;
      canvas.addEventListener("click", function (e) {
        that.handleClickCanvas(e);
      });
      canvas.addEventListener(
        "mousemove",
        function (e) {
          if (e.pageX || e.pageY) {
            x = e.offsetX;
            y = e.offsetY;
          } else {
            x =
              e.clientX +
              document.body.scrollLeft +
              document.documentElement.scrollLeft;
            y =
              e.clientY +
              document.body.scrollTop +
              document.documentElement.scrollTop;
          }
          that.pointX = x;
          that.pointY = y;
        },
        false
      );
    },
    // 根据点击的位置寻找符合要求范围的设备，图片r:25
    handleClickCanvas(e) {
      let x = e.offsetX;
      let y = e.offsetY;
      let possiblyDevice = [];
      this.canvasList.forEach((el, index) => {
        let wb = this.cW / el.width;
        let hb = this.cH / el.height;
        let scope =
          Math.pow(x - el.abscissa * wb, 2) + Math.pow(y - el.ordinate * hb, 2);
        if (scope < 25 * 25) {
          let obj = {
            ...el,
            distance: scope - 25 * 25,
          };
          possiblyDevice.push(obj);
        }
      });
      // 如果存在多个符合要求的设备,按距离取最近的设备
      if (possiblyDevice.length > 1) {
        possiblyDevice = possiblyDevice.sort((a, b) => {
          return a.distance - b.distance;
        });
      }
      possiblyDevice.length && this.getDeviceDetail(possiblyDevice[0]);
    },
    getDeviceDetail(info) {
      this.$fetch(api.fire.getDeviceDetail, {
        deviceId: info.deviceId,
      }).then((res) => {
        if (res.success) {
          this.deviceInfo = res.returnObj.deviceInfo;
          this.showDeviceTip = true;
          this.matchTip();
        } else {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    getCanvasWH() {
      // 分辨率发生变化
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.mathCanvas();
      this.matchTip();
    },
    // 计算弹窗位置
    matchTip() {
      if (this.canvasList.length && this.showDeviceTip) {
        this.canvasList.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          // 显示该设备tip
          if (el.deviceId == this.deviceInfo.deviceId) {
            this.tipStyle.left = Math.round(
              el.abscissa * wb + this.getMarinLeft - 163
            );
            this.tipStyle.top = Math.round(
              el.ordinate * hb + this.getMarginTop + 25
            );
          }
        });
      }
    },
    mathCanvas() {
      this.clearCanvas();
      if (!this.tipImg) {
        setTimeout(() => {
          this.mathCanvas();
        }, 500);
        return;
      }
      let img = this.tipImg;
      let ctx = this.initCanvas();
      if (this.canvasList.length) {
        this.canvasList.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          this.$nextTick(() => {
            ctx.drawImage(
              img,
              Math.round(el.abscissa * wb - 25),
              Math.round(el.ordinate * hb - 25),
              50,
              50
            );
          });
        });
      }
    },
    handleClosePanel() {
      this.handleResetCanvas();
      this.$app.AppInstance.handleMiniPlay(); //关闭播放器
      this.showDrawPanel = false;
      this.$emit("handleCloseFloor");
    },
    handleResetCanvas() {
      this.clearCanvas();
      this.vW = 100;
      this.vH = 100;
      this.marginTop = 0;
      this.moveYDistance = 0;
      this.marginLeft = 0;
      this.moveXDistance = 0;
      this.pointX = 0;
      this.pointY = 0;
      this.canvasList = [];
      this.showDeviceTip = false;
    },
    getImgPath(fileCode) {
      return fileCode ? Bus.imgPath(fileCode) : "";
    },
    handleOpenPanel(info, buildInfo) {
      // info楼层  buildInfo 楼栋
      this.floorInfo = JSON.parse(JSON.stringify(info));
      this.buildInfo = JSON.parse(JSON.stringify(buildInfo));
      this.showDrawPanel = true;
      console.log("楼层信息", info);
      console.log("楼栋信息", buildInfo);
      this.getIndoorDeviceList(this.floorInfo);
    },
    // 查询楼层下设备
    getIndoorDeviceList(info) {
      let params = {
        buildingCode: info.buildingCode, //所在位置id
        deviceTypeList: ["10"], //摄像机
      };
      this.handleResetCanvas();
      this.$fetch(api.getIndoorDeviceList, params).then((res) => {
        if (res.success) {
          this.canvasList = res.returnObj;
          this.mathCanvas();
        } else {
          this.$message.error("获取该楼层设备失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.canvasTip {
  z-index: 2;
  position: absolute;
}
.dialog-app-panel {
  //   pointer-events: none;
  z-index: 10;
}
:deep .app-side-panel {
  pointer-events: all;
  &__body {
    flex-direction: row;
    overflow: hidden;
  }
}
.coord {
  //   width: 100%;
  display: flex;
  justify-content: space-between;
  position: absolute;
  right: 0%;
  min-width: 210px;
  background: rgba(13, 18, 28, 0.7);
  padding: 5px 10px;
  color: #fff;
}
.floors {
  max-width: 150px;
  min-width: 100px;
  padding-right: 8px;
  .floor-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    color: #42526e;
    cursor: pointer;
    i {
      font-size: 20px;
      margin-right: 8px;
      opacity: 0;
    }
    &:hover {
      color: black;
    }
    &.active {
      color: black;
      font-weight: bold;
      i {
        opacity: 1 !important;
      }
    }
    .floor-name {
      letter-spacing: 3px;
    }
  }
}
.canvasMain {
  position: relative;
  background: rgba(128, 128, 128, 0.5);
  width: 100%;
  height: 100%;
  overflow: hidden;

  .canvasMainT {
    position: absolute;
    #floorImg {
      width: 100%;
      height: 100%;
      position: absolute;
    }
    canvas {
      position: absolute;
    }
  }
}
</style>
